import {
	ReactElement,
	Ref,
	RefObject,
	useRef
} from "react";
import { Button, ButtonProps } from "../Button/Button";
import { useCopyToClipboard } from "client/Hooks";
import { mergeRefs } from "client/Misc/reactUtils";

export type CopyButtonProps = ButtonProps & {
	value: string;
	ref?: Ref<HTMLButtonElement>;
};

export const CopyButton = (props: CopyButtonProps): ReactElement => {
	const {
		value,
		ref,
		...rest
	} = props;

	const buttonRef: RefObject<HTMLButtonElement | null> = useRef<HTMLButtonElement>(null);

	useCopyToClipboard(
		buttonRef,
		value
	);

	return (
		<Button
			{...rest}
			ref={ref ? mergeRefs(ref, buttonRef) : buttonRef}
		/>
	);
};

CopyButton.displayName = "CopyButton";
